// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__-gkRr","header":"MessagesList_header__RT_Mj","chat":"MessagesList_chat__2HnwM"};